import { connect } from 'react-redux'
import UI from './UI'

const mapStateToProps = ({ learningPath, referential, user }) => ({
  loading: learningPath.isLearningPathLoading,
  ProfileType: referential?.ProfileTypes ? referential?.ProfileTypes[user?.ProfileType] : null,
  Description: learningPath.LearningPath.Description,
  Objectives: learningPath.LearningPath.Objectives,
  PreRequirements: learningPath.LearningPath.PreRequirements,
  PublicConcerned: learningPath.LearningPath.ConcernedAudience,
  learningPathId: learningPath.LearningPath.Id,
  learningPathProjects: learningPath.CoursePathProjects,
  PresentationVideoThumbnail: learningPath.LearningPath.VideoPresentationBackgroundImage
})

export default connect(mapStateToProps, null)(UI)
